module.exports = __webpack_public_path__ + "img/slika3_2022.192c2b27.png";